import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { QueryState } from 'src/app/core/models/query.model';
import { Psa, PsaType } from './psa.model';


export const PSA_ENDPOINT = 'psa';
export const PSA_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PSA_ENDPOINT);

export const PSA_TYPE_ENDPOINT = 'psa-type'
export const PSA_TYPE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PSA_TYPE_ENDPOINT);

export const TEMPLATE_ENDPOINT = 'templates'
export const TEMPLATE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(TEMPLATE_ENDPOINT);

export const SUBMISSION_ENDPOINT = 'submission';
export const SUBMISSION_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(SUBMISSION_ENDPOINT);

export const SUBMISSION_TYPE_ENDPOINT = 'submission-type';
export const SUBMISSION_TYPE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(SUBMISSION_TYPE_ENDPOINT);

export const REGIONS_ENDPOINT = 'regions';
export const REGIONS_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(REGIONS_ENDPOINT);

export const EGATO_ENDPOINT = 'egato';
export const EGATO_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(EGATO_ENDPOINT);

export const ASL_ENDPOINT = 'asl';
export const ASL_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(ASL_ENDPOINT);

export const SNPA_ENDPOINT = 'snpa';
export const SNPA_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(SNPA_ENDPOINT);

export const PSA_DETAIL_ENDPOINT = 'psa';
export const PSA_INDICE_ENDPOINT = 'indiceForm/all';

export const PSA_WSZ_ENDPOINT = 'psa-wsz';
export const PSA_WSZ_SERVICE_INSTANCE = createTokenQueryServiceInstance(PSA_WSZ_ENDPOINT);

export const PSA_INDICE_PROVA_ENDPOINT = 'indiceForm/prova';

export const psaStateConfig: SignalStoreConfig<QueryState<Psa>> = {
    initState: {
      list: []
    }
  }

export const psaTypeStateConfig: SignalStoreConfig<QueryState<Psa>> = {
  initState: {
    list: []
  }
}

export const templateStateConfig: SignalStoreConfig<QueryState<Psa>> = {
  initState: {
    list: []
  }
}

export const regionsStateConfig: SignalStoreConfig<QueryState<any>> = {
    initState: {
      list: [],
      sort: {
        field: 'denominazioneRegione',
        direction: 'asc'
      }
    }
  }

export const egatoStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const aslStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const snpaStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const psaWszStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

//da togliere
export const psaSingleStateConfig = {
  initState: {
    psa: null,
  }
}
export const LISTA_PSA_COLUMNS: any[] = [
  {
    name: 'id',
    label: 'id',
    field: 'id',
   type:'text'
  },
  {
    name: 'name',
    label: 'Nome PSA',
    field: 'name',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'managerCode',
    label: 'Codice Gestore',
    field: 'managerCode',
    type:'text'
  },
  {
    name: 'state',
    label: 'Stato',
    field: 'state',
    type:'text'
  },
  {
    name: 'validityStatus',
    label: 'Validità del Psa',
    field: 'validityStatus',
    type:'text'
  },
  {
    name: 'updatedAt',
    label: 'Ultima Modifica',
    field: 'updatedAt',
    type:'datetime'
  },
/*   {
    name: 'psaType',
    label: 'processo',
    field: 'psaType',
    cell:(el:PsaType)=>el.name
  },
  {
    name: 'state',
    label: 'Form Corrente',
    field: 'state',
  }, */
];

export const LISTA_PSA_VISIBLECOLUMNS = [

  'name',
  'state',
  'validityStatus',
  'updatedAt',
/*   'psaType',
  'state', */
  'azioni'
];


export const LISTA_DETTAGLIO_PSA_COLUMNS: any[] = [
  {
    name: 'id',
    label: 'id',
    field: 'id',
    primaryKey: true,
  },
  {
    name: 'collectionName',
    label: 'Nome',
    field: 'collectionName',
  },

];

export const LISTA_DETTAGLIO_PSA_VISIBLECOLUMNS = [
  'id',
  'collectionName',
];
